/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiOrderItem,
  ApiOrderItemFromJSON,
  ApiOrderItemFromJSONTyped,
  ApiOrderItemToJSON,
} from './ApiOrderItem';

/**
 *
 * @export
 * @interface ApiPetPrescriptionLastOrder
 */
export interface ApiPetPrescriptionLastOrder {
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescriptionLastOrder
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescriptionLastOrder
   */
  omsOrderStatus?: ApiPetPrescriptionLastOrderOmsOrderStatusEnum;
  /**
   *
   * @type {Array<ApiOrderItem>}
   * @memberof ApiPetPrescriptionLastOrder
   */
  orderItems?: Array<ApiOrderItem>;
}

/**
 * @export
 */
export const ApiPetPrescriptionLastOrderOmsOrderStatusEnum = {
  Backordered: 'BACKORDERED',
  Canceled: 'CANCELED',
  CsrEdit: 'CSR_EDIT',
  Deposited: 'DEPOSITED',
  NoInventory: 'NO_INVENTORY',
  PaymentInitiated: 'PAYMENT_INITIATED',
  PaymentRequiresReview: 'PAYMENT_REQUIRES_REVIEW',
  ReadyToRelease: 'READY_TO_RELEASE',
  Released: 'RELEASED',
  Shipped: 'SHIPPED',
  Submitted: 'SUBMITTED',
  SubmittedIncomplete: 'SUBMITTED_INCOMPLETE',
  Unknown: 'UNKNOWN',
} as const;
export type ApiPetPrescriptionLastOrderOmsOrderStatusEnum = typeof ApiPetPrescriptionLastOrderOmsOrderStatusEnum[keyof typeof ApiPetPrescriptionLastOrderOmsOrderStatusEnum];

export function ApiPetPrescriptionLastOrderFromJSON(json: any): ApiPetPrescriptionLastOrder {
  return ApiPetPrescriptionLastOrderFromJSONTyped(json, false);
}

export function ApiPetPrescriptionLastOrderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetPrescriptionLastOrder {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    orderId: !exists(json, 'orderId') ? undefined : json['orderId'],
    omsOrderStatus: !exists(json, 'omsOrderStatus') ? undefined : json['omsOrderStatus'],
    orderItems: !exists(json, 'orderItems')
      ? undefined
      : (json['orderItems'] as Array<any>).map(ApiOrderItemFromJSON),
  };
}

export function ApiPetPrescriptionLastOrderToJSON(value?: ApiPetPrescriptionLastOrder | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    orderId: value.orderId,
    omsOrderStatus: value.omsOrderStatus,
    orderItems:
      value.orderItems === undefined
        ? undefined
        : (value.orderItems as Array<any>).map(ApiOrderItemToJSON),
  };
}
